exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-btm[data-v-74f46e54]{border-bottom:1px solid #e7e7e7;padding-top:15px}ol[data-v-74f46e54]{list-style-type:upper-roman}.big-header[data-v-74f46e54]{font-size:4.5rem;text-align:center;margin-bottom:70px}.big-header span[data-v-74f46e54]{font-size:6rem!important;font-weight:bolder;color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74f46e54","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mittags-tisch/WeekPlan.vue
// module id = 72
// module chunks = 0